module.exports = __webpack_public_path__ + "static/media/Piercing-tongue-bodyPart.2d84096c.png";